import { ShopRendererApiClient } from '@fourthwall/services/dist/ShopRendererApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useUpdateHMACMutation = createMutationHook(ShopRendererApiClient.updateHMAC, {
  mutationKey: ['updateHMAC'],
})
